export default __webpack_public_path__ + "static/media/active2.ab6ccb61.svg";